// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-manifest-goods-info[data-v-4f32e5d2] .required-label .ag-header-cell-text {\n  color: #1F75D5 !important;\n}\n", ""]);
// Exports
module.exports = exports;
